import { render, staticRenderFns } from "./ReviewSurvey.vue?vue&type=template&id=27089a9c&scoped=true&"
import script from "./ReviewSurvey.vue?vue&type=script&lang=ts&"
export * from "./ReviewSurvey.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewSurvey.vue?vue&type=style&index=0&id=27089a9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27089a9c",
  null
  
)

export default component.exports